<button class="btn-copy" title="copy" (click)="copy()">
  <span class="material-symbols-outlined"> content_copy </span>
</button>
